export function createSchoolSearchAPIURL(schoolId, max, index, itemType, historical) {
    const apiUri = new Uri(baseURL + '/common/json_school.html');

    apiUri.addQueryParam('APIKey', dcAPIKey);
    apiUri.addQueryParam('school', schoolId);

    if (historical) {
        apiUri.addQueryParam('historical', historical);
    }

    appendUriMaxAndIndex(apiUri, itemType, index, max);
    return apiUri.toString();
}

export function createTeacherSearchAPIURL(teacherId, index, fundedProjectsYear) {
    const apiUri = new Uri(baseURL + 'common/json-teacher.html');

    apiUri.addQueryParam('APIKey', dcAPIKey);
    apiUri.addQueryParam('teacher', teacherId);
    appendUriMaxAndIndex(apiUri, null, index);

    if (fundedProjectsYear) {
        apiUri.addQueryParam('historical', true);
        apiUri.addQueryParam('newSince', +new Date(fundedProjectsYear, 0, 1));
        apiUri.addQueryParam('olderThan', +new Date(fundedProjectsYear + 1, 0, 1));
    }

    return apiUri.toString();
}

export function createChallengeSearchAPIURL(baseChallengeUrl, challengeId, itemType, historical, index, max, isCampaign, batchnames, hiddenProjects, matchingIds) {
    const apiUri = new Uri(baseURL + baseChallengeUrl);

    apiUri.addQueryParam('APIKey', dcAPIKey);

    if (!isCampaign) {
        apiUri.addQueryParam('id', challengeId);
    } else {
        let searchQuery = buildCampaignSearchQuery(batchnames, hiddenProjects);

        apiUri.addQueryParam('solrQuery', searchQuery);
    }

    if (historical) {
        apiUri.addQueryParam('historical', historical);
    }

    appendUriMaxAndIndex(apiUri, itemType, index, max);
    return apiUri.toString();
}

// default max is 10, default index is 0
function appendUriMaxAndIndex(apiUri, itemType, index, max) {
    const type = (itemType === 'teachers' || itemType === 'supporters' || itemType === 'angels') ? itemType : '';
    apiUri.addQueryParam(type + 'max', max || 10);
    apiUri.addQueryParam(type + 'index', index || 0);
}

function buildCampaignSearchQuery(batchnames, hiddenProjects, matchingIds) {
    let searchQuery;
    if (isPresent(matchingIds)) {
        searchQuery = 'bestmatching:(' + matchingIds.join(' OR ') + ')';
    } else {
        searchQuery = 'supportingbatchnames:("' + batchnames.join('" OR "') + '")';
    }

    if (isPresent(hiddenProjects)) {
        searchQuery = searchQuery + ' AND -id:(' + hiddenProjects.join(' OR ') + ')';
    }

    return searchQuery;
}

function isPresent(value) {
    return value !== undefined && value !== null && value.length > 0;
}
